
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { ContentDto, AccordionContent } from 'fourwaves-shared';
import { Collapsible } from 'fourwaves-shared/components';

@Component({
  components: {
    Collapsible,
  },
})
export default class AccordionContentBlock extends Vue {
  @Prop({ required: true }) content!: ContentDto;
  sections: (AccordionContent & { isVisible: boolean })[] = [];

  created() {
    if (this.content.data && this.transl8(this.content.data)) {
      const sections = JSON.parse(this.transl8(this.content.data)) as AccordionContent[];
      this.sections.push(...sections.map(section => ({ ...section, isVisible: false })));
    }
  }
}
